"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var client_lib_js_player_framework_utils_1 = require("@sky-uk-ott/client-lib-js-player-framework-utils");
var EMPTY = '{%EMPTY%}';
var EMPTY_STRING = '{%EMPTY_STRING%}';
var KEYS_LOCATION = '{%CTV_KEYS%}';
var STORAGE_POLL_PERIOD = 100;
var STORAGE_MAX_WAIT = 2000;
var TEST_KEY = '{%CTV_TEST%}';
var PERSISTENT_TEST_KEY = '{%CTV_PERSISTENT_TEST%}';
var PERSISTENT_TEST_VALUE = 'REALLY_PERSISTENT';
var NUM_PERSISTENT_CHECKS = 3;
var READ_RETRIES = 2;
var WRITE_RETRIES = 2;
var WebMafStorage = (function () {
    function WebMafStorage(webMafBridge) {
        this.webMafBridge = webMafBridge;
        this.keys = new Set();
    }
    WebMafStorage.prototype.initialise = function () {
        var _this = this;
        return this.waitForStorageToBeAvailable().then(function () {
            return _this.readUsedKeys();
        });
    };
    WebMafStorage.prototype.setItem = function (key, value) {
        var _this = this;
        var setItem = function () {
            _this.writeItem(key, value);
            var savedValue = _this.readItem(key);
            for (var currentRetries = 0; savedValue !== value && value !== null && currentRetries < WRITE_RETRIES; currentRetries++) {
                _this.writeItem(key, value);
                savedValue = _this.readItem(key);
            }
        };
        return client_lib_js_player_framework_utils_1.promisifySynchronousMethod(setItem);
    };
    WebMafStorage.prototype.getItem = function (key) {
        var _this = this;
        return client_lib_js_player_framework_utils_1.promisifySynchronousMethod(function () { return _this.readItem(key); });
    };
    WebMafStorage.prototype.removeItem = function (key) {
        var _this = this;
        var removeItem = function () {
            _this.write(key, EMPTY);
            _this.keys.delete(key);
            _this.writeUsedKeys();
        };
        return client_lib_js_player_framework_utils_1.promisifySynchronousMethod(removeItem);
    };
    WebMafStorage.prototype.clear = function () {
        var _this = this;
        return client_lib_js_player_framework_utils_1.promisifySynchronousMethod(function () { return _this.keys.forEach(function (key) { return _this.removeItem(key); }); });
    };
    WebMafStorage.prototype.setSecureItem = function (key, value) {
        return this.setItem(key, value);
    };
    WebMafStorage.prototype.getSecureItem = function (key) {
        return this.getItem(key);
    };
    WebMafStorage.prototype.removeSecureItem = function (key) {
        return this.removeItem(key);
    };
    WebMafStorage.prototype.clearSecure = function () {
        return this.clear();
    };
    WebMafStorage.prototype.read = function (key) {
        return this.webMafBridge.getFileApi().read(key);
    };
    WebMafStorage.prototype.write = function (key, value) {
        this.webMafBridge.getFileApi().write(key, value);
    };
    WebMafStorage.prototype.readItem = function (key) {
        var value = this.read(key);
        for (var retries = 0; value === '' && retries < READ_RETRIES; retries++) {
            value = this.read(key);
        }
        if (value === EMPTY || value === '') {
            return null;
        }
        else if (value === EMPTY_STRING) {
            return '';
        }
        else {
            return value;
        }
    };
    WebMafStorage.prototype.writeItem = function (key, value) {
        var valueToWrite = value === '' ? EMPTY_STRING : value;
        this.write(key, valueToWrite);
        this.keys.add(key);
        this.writeUsedKeys();
    };
    WebMafStorage.prototype.readUsedKeys = function () {
        var _this = this;
        return this.getItem(KEYS_LOCATION).then(function (keysString) {
            if (keysString) {
                _this.keys = new Set(JSON.parse(keysString));
            }
        });
    };
    WebMafStorage.prototype.writeUsedKeys = function () {
        this.write(KEYS_LOCATION, JSON.stringify(Array.from(this.keys)));
    };
    WebMafStorage.prototype.waitForStorageToBeAvailable = function () {
        var _this = this;
        var startTime = new Date().getTime();
        return new Promise(function (resolve, reject) {
            var pollStorage = function () {
                var isStorageWritable = _this.isStorageWritable();
                var isPersistentTestValueFound = _this.isPersistentTestValueFound();
                var timeWaitedForStorage = new Date().getTime() - startTime;
                if (isStorageWritable && isPersistentTestValueFound) {
                    resolve();
                }
                else if (timeWaitedForStorage >= STORAGE_MAX_WAIT && isStorageWritable) {
                    _this.setItem(PERSISTENT_TEST_KEY, PERSISTENT_TEST_VALUE);
                    resolve();
                }
                else if (timeWaitedForStorage >= STORAGE_MAX_WAIT) {
                    reject(new Error('Storage not available'));
                }
                else {
                    setTimeout(pollStorage, STORAGE_POLL_PERIOD);
                }
            };
            pollStorage();
        });
    };
    WebMafStorage.prototype.isPersistentTestValueFound = function () {
        try {
            for (var checks = 0; checks < NUM_PERSISTENT_CHECKS; checks++) {
                var testValue = this.read(PERSISTENT_TEST_KEY);
                if (testValue !== PERSISTENT_TEST_VALUE) {
                    return false;
                }
            }
            return true;
        }
        catch (e) {
            return false;
        }
    };
    WebMafStorage.prototype.isStorageWritable = function () {
        var timestamp = new Date().getTime().toString();
        try {
            this.write(TEST_KEY, timestamp);
            return this.read(TEST_KEY) === timestamp;
        }
        catch (e) {
            return false;
        }
    };
    return WebMafStorage;
}());
exports.WebMafStorage = WebMafStorage;
